import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkyRowComponent } from './row.component';
import { SkyColumnComponent } from './column.component';


export class SkyFluidGridModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [
    SkyRowComponent,
    SkyColumnComponent
  ],
  exports: [
    SkyRowComponent,
    SkyColumnComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
